const fr = {
  common: {
    save: "Enregistrer",
    cancel: "Annuler",
    edit: "Modifier",
    delete: "Supprimer",
    close: "Fermer",
    discardChanges: "Annuler les modifications",
    saveChanges: "Enregistrer les modifications",
    add: "AJOUTER",
    create: "Créer",
    import: "Importer",
    email: "E-mail",
    firstName: "Prénom",
    lastName: "Nom",
    name: "Nom",
    address: "Adresse",
    postalCode: "Code postal",
    city: "Ville",
    country: "Pays",
    vatNumber: "Numéro de TVA",
    identificationNumber: "Numéro d'identification",
    picture: "Photo",
    updateAvatar: "Changer l'avatar",
    uploadNewPicture: "Choisir une nouvelle photo de profil",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    leaveBlankPassword: "Laisser vide pour conserver le mot de passe actuel",
    switchLanguage: "Changer de langue",
    createOne: "En créer une",
    createOrganization: "Créer une organisation",
    role: "Rôle",
    confirm: "Confirmer",
    select: "Sélectionner",
    collapse: "Réduire",
    expand: "Agrandir",
    roleOwner: "Propriétaire",
    roleAdmin: "Administrateur",
    roleMember: "Membre",
    roleReader: "Lecteur",
    selectAClient: "Sélectionner un client",
    client: "Client",
    color: "Couleur",
    globalRoleSuperuser: "Super-administrateur",
    globalRoleConfirmed: "Confirmé",
    globalRoleDisabled: "Désactivé",
    globalRoleBan: "Banni",
    currency: "Devise",
    language: "Langue",
    all: "Tous",
    selectedOne: "1 sélectionné",
    selectedCount: "{{count}} sélectionnés",
    search: "Rechercher...",
    noResults: "Aucun résultat",
    clearFilter: "Effacer",
    selectAll: "Tout sélectionner",
    suggestions: "Suggestions",
    cropImageTitle: "Ajustez votre image",
    copy: "Copier",
    copied: "Copié dans le presse-papiers",
    copyId: "Copier l'ID",
  },
  cookieBanner: {
    title: "Avis relatif aux cookies",
    message:
      "CWClock est un produit open-source. Les cookies et le stockage local qu'il utilise sont nécessaires uniquement au fonctionnement de l'application (connexion, thème et langue) - jamais pour le suivi ou l'analyse.",
    understand: "J'ai compris",
  },
  days: {
    0: "Dimanche",
    1: "Lundi",
    2: "Mardi",
    3: "Mercredi",
    4: "Jeudi",
    5: "Vendredi",
    6: "Samedi",
  },
  nav: {
    cwclock: "CWClock",
    cwclockHome: "Accueil CWClock",
    switchOrganization: "Changer d'organisation",
    createOrganization: "Créer une organisation",
    gitRepository: "Dépôt Git",
    documentation: "Documentation",
    contactForm: "Nous contacter",
    downloadAndroidApp: "Télécharger l'application Android",
    scanToDownloadAndroidApp: "Scannez ce QR code avec votre appareil Android pour télécharger l'application.",
    editProfile: "Modifier le profil",
    editProfileTooltip: "Modifier votre profil et votre avatar",
    lightMode: "Mode clair",
    darkMode: "Mode sombre",
    switchToLightMode: "Passer au mode clair",
    switchToDarkMode: "Passer au mode sombre",
    logout: "Déconnexion",
    login: "Connexion",
    goToLogin: "Aller à la page de connexion",
    collapseSidebar: "Réduire le menu",
    expandSidebar: "Agrandir le menu",
    timeTracker: "Suivi du temps",
    calendar: "Calendrier",
    reports: "Rapports",
    organizations: "Organisations",
    clients: "Clients",
    projects: "Projets",
    users: "Utilisateurs",
    organizationsAdmin: "Organisations",
    apiKeys: "Clés API",
    invoices: "Factures",
    exportJobs: "Tâches d'export",
  },
  auth: {
    doesNotHaveAccount: "Vous n'avez pas de compte ?",
    signUp: "S'inscrire",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    logIn: "Connexion",
    enterEmail: "Entrez votre e-mail",
    emailAddress: "Adresse e-mail",
    password: "Mot de passe",
    logInToAccount: "Connectez-vous à votre compte",
    getStartedTitle: "Commencez avec CWClock",
    getStartedSubtitle: "Créez un compte pour suivre votre temps et améliorer votre productivité.",
    createAccount: "Créer un compte",
    createAccountTitle: "Créez votre compte",
    passwordsDontMatch: "Les mots de passe ne correspondent pas.",
    openSourceBy: "Solution open source par ",
    cwcloudLinkLabel: "CWCloud.tech",
    openSourceSuffix: ", les sources sont disponibles",
    here: "ici",
    documentationAvailable: ", la documentation est disponible",
    orContinueWith: "Ou continuer avec",
    continueWithGoogle: "Continuer avec Google",
    continueWithGithub: "Continuer avec GitHub",
    continueWithKeycloak: "Continuer avec Keycloak",
    forgotPassword: "Mot de passe oublié ?",
    forgotPasswordTitle: "Réinitialiser votre mot de passe",
    forgotPasswordBody: "Saisissez votre adresse email, nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    sendResetLink: "Envoyer le lien",
    backToLogin: "Retour à la connexion",
    resetPasswordTitle: "Choisissez un nouveau mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    resetPassword: "Réinitialiser le mot de passe",
    missingResetToken: "Ce lien de réinitialisation est invalide.",
    confirmationSuccess: "Votre compte a été confirmé. Vous pouvez maintenant vous connecter.",
    confirmationInvalid: "Ce lien de confirmation est invalide ou a expiré.",
    confirmationBanned: "Ce compte a été banni.",
    mfaChallengeTitle: "Authentification à deux facteurs",
    mfaCodePlaceholder: "Code à 6 chiffres",
    mfaVerify: "Vérifier",
    mfaUseSecurityKey: "Utiliser une clé de sécurité",
  },
  timeTracker: {
    whatAreYouWorkingOn: "Sur quoi travaillez-vous ?",
    searchByCustomerOrProject: "Rechercher par client ou par projet",
    project: "Projet",
    elapsedTime: "Temps écoulé",
    stopTimer: "Arrêter le chronomètre",
    startTimer: "Démarrer le chronomètre",
    stop: "Arrêter",
    start: "Démarrer",
    currentTime: "Heure actuelle",
    emptyTitle: "Commençons à suivre votre temps !",
    emptyBody: "Choisissez un projet ci-dessus et démarrez le chronomètre.",
    needOrganization: "Vous avez besoin d'une organisation pour suivre votre temps.",
    taskDescription: "Description",
    day: "Jour",
    allDay: "Toute la journée",
    markAllDay: "Marquer comme une entrée de toute la journée",
    half: "Demi-journée",
    markHalf: "Marquer comme une entrée de demi-journée",
    startTime: "Heure de début",
    endTime: "Heure de fin",
    reassignToMember: "Réattribuer à un membre",
    searchMember: "Rechercher un membre...",
    deleteRecordTitle: "Supprimer l'entrée de temps",
    deleteRecordBody: "Voulez-vous vraiment supprimer « {{text}} » ? Cette action est irréversible.",
    importCsv: "Importer un CSV",
    importCsvTitle: "Importer des entrées de temps depuis un CSV",
    importCsvHint:
      "Importez un CSV de rapport détaillé (depuis Clockify, ou exporté depuis une autre organisation cwclock). Les clients, projets et utilisateurs sont créés automatiquement s'ils n'existent pas ; les entrées déjà existantes sont ignorées.",
    importCsvFile: "Fichier CSV",
    importResult: "Import terminé : {{created}} entrées créées, {{skipped}} ignorées.",
  },
  calendar: {
    today: "Aujourd'hui",
    previousMonth: "Mois précédent",
    nextMonth: "Mois suivant",
    monthView: "Mois",
    weekView: "Semaine",
    addTimeRecord: "Ajouter une entrée de temps",
    editTimeRecord: "Modifier l'entrée de temps",
    start: "Début",
    end: "Fin",
    endSameDayHint: "La fin doit être le même jour que le début - les entrées sur plusieurs jours ne sont pas encore prises en charge.",
    fillRequiredFields: "Veuillez renseigner la description, le projet et la date.",
    moreEntries: "+{{count}} de plus",
    allDayRowLabel: "Toute la journée",
    shareTitle: "Partager le calendrier",
    shareIntro: "Abonnez-vous à vos entrées de temps depuis Outlook ou Google Agenda grâce à ce lien personnel.",
    shareEnable: "Activer le partage du calendrier",
    shareRegenerate: "Générer un nouveau lien",
    shareHint:
      "Toute personne disposant de ce lien peut voir vos entrées de temps. Dans Google Agenda : Paramètres > Ajouter un agenda > « À partir de l'URL ». Dans Outlook : Ajouter un calendrier > « S'abonner depuis le web ».",
  },
  profile: {
    editProfileTitle: "Modifier le profil",
    pleaseAddNames: "Veuillez renseigner votre prénom et votre nom.",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas.",
    passwordsMatch: "Les mots de passe correspondent.",
    couldNotUpdate: "Impossible de mettre à jour votre profil. Veuillez réessayer.",
    saveProfile: "Enregistrer votre profil",
    mfaTitle: "Authentification à deux facteurs",
    mfaTotp: "Application d'authentification",
    mfaWebAuthn: "Clés de sécurité",
    mfaEnable: "Activer",
    mfaDisable: "Désactiver",
    mfaConfirm: "Confirmer",
    mfaSecretHint: "Ou saisissez ce code manuellement : {{secret}}",
    mfaRegisterKey: "Enregistrer une clé de sécurité",
    mfaSecurityKeyNamePrompt: "Nommez cette clé de sécurité",
    mfaSecurityKeyNameLabel: "Nom de l'appareil",
    mfaSecurityKeyDefaultName: "Clé de sécurité",
    mfaDisableTitle: "Désactiver l'authentification à deux facteurs",
    mfaDisableBody: "Désactiver l'application d'authentification pour votre compte ?",
    mfaDeleteKeyTitle: "Supprimer la clé de sécurité",
    mfaDeleteKeyBody: 'Supprimer la clé de sécurité "{{name}}" ? Cette action est irréversible.',
  },
  disabled: {
    adminMode: {
      title: "Compte désactivé",
      body: "Votre compte est désactivé. Veuillez contacter un administrateur pour obtenir l'accès.",
    },
    emailMode: {
      title: "Confirmez votre compte",
      body: "Veuillez consulter votre email et cliquer sur le lien de confirmation pour activer votre compte.",
    },
    signOut: "Se déconnecter",
  },
  banned: {
    title: "Compte banni",
    body: "Votre compte a été banni par un administrateur.",
    signOut: "Se déconnecter",
  },
  organizations: {
    title: "Organisations",
    switchTo: "Passer à {{name}}",
    createOrganization: "Créer une organisation",
    editOrgTitle: "Modifier {{name}}",
    editOrganization: "Modifier l'organisation",
    accountingEmail: "Email de la comptabilité",
    accountingEmailPlaceholder: "Optionnel - en copie de chaque email de facture",
    iban: "IBAN",
    bic: "BIC",
    editOrgTooltip: "Modifier les informations de cette organisation",
    membersOf: "Membres de {{name}}",
    addMemberPanel: "Ajouter un membre",
    memberEmail: "E-mail du membre",
    inviteMember: "Inviter ce membre",
    addMemberButton: "Ajouter le membre",
    couldNotAddMember: "Impossible d'ajouter ce membre. Vérifiez l'e-mail et réessayez.",
    transferOwnership: "Transférer la propriété",
    newOwnerEmail: "E-mail du nouveau propriétaire",
    transferOwnershipTooltip: "Transférer la propriété à ce membre",
    confirmTransfer: 'Transférer la propriété de "{{name}}" à {{email}} ? Cette action est irréversible.',
    couldNotTransfer: "Impossible de transférer la propriété. Vérifiez l'e-mail et réessayez.",
    nameRequired: "Le nom est requis.",
    noDailyRateSet: "Aucun taux journalier défini",
    dailyRatePerDay: "{{rate}} {{currency}}/jour",
    editDailyRate: "Modifier le taux journalier",
    dailyRate: "Taux journalier",
    currency: "Devise",
    saveDailyRate: "Enregistrer le taux journalier",
    selectOrCreateFirst: "Sélectionnez ou créez d'abord une organisation",
    stamp: "Cachet",
    naf: "Code NAF",
    emptyTitle: "Aucune organisation pour le moment",
    emptyBody: "Créez votre première organisation ci-dessous pour commencer.",
    externalConnections: "Connexions externes",
    addConnection: "Ajouter une connexion",
    connectionType: "Type de connexion",
    s3: "S3",
    googleDrive: "Google Drive",
    git: "Git",
    endpoint: "Point de terminaison",
    bucketName: "Nom du bucket",
    region: "Région",
    accessKey: "Clé d'accès",
    secretKey: "Clé secrète",
    serviceAccount: "Compte de service (JSON)",
    serviceAccountReadError: "Impossible de lire ce fichier.",
    folderId: "ID du dossier",
    repoUrl: "URL du dépôt",
    subfolderPath: "Sous-dossier (facultatif)",
    subfolderPathPlaceholder: "ex. invoices/cwclock",
    subfolderPathHint: "Sous-dossier dans lequel les fichiers sont écrits - dans le dépôt pour git, le bucket pour S3, ou le dossier pour Google Drive. Laissez vide pour utiliser sa racine.",
    gitAuthMethod: "Méthode d'authentification",
    gitAuthMethodPassword: "Identifiant / mot de passe",
    gitAuthMethodSshKey: "Clé SSH",
    gitUsername: "Identifiant",
    gitPassword: "Mot de passe",
    sshPrivateKey: "Clé privée SSH",
    sshPrivateKeyPassphrase: "Phrase secrète de la clé privée SSH (facultatif)",
    flatDirectory: "Répertoire à plat (sans sous-dossiers)",
    flatDirectoryHint: "Téléverse les fichiers directement à la racine au lieu de les ranger dans des dossiers AAAA/MM - utile pour les logiciels de comptabilité qui exigent une liste à plat.",
    flatDirectoryBadge: "à plat",
    deleteConnectionTitle: "Supprimer la connexion",
    deleteConnectionBody: 'Supprimer la connexion "{{name}}" ? Cette action est irréversible.',
    revokeMember: "Révoquer ce membre",
    revokeMemberTitle: "Révoquer le membre",
    revokeMemberBody: "Révoquer {{name}} de cette organisation ? Cette action est irréversible.",
  },
  clients: {
    title: "Clients",
    createClient: "Créer un client",
    vatRateLabel: "Taux de TVA % (par défaut 20%)",
    vatDischargeMotive: "Motif d'exonération de TVA",
    contactName: "Nom du contact",
    purchaseOrder: "Bon de commande",
    hoursPerDay: "Heures/jour (par défaut 7)",
    dailyRate: "Taux journalier (prioritaire sur celui du membre)",
    sendReportsWithInvoice: "Envoyer aussi les rapports (synthèse et détaillé) avec les emails de facture",
    dailyRateSet: " - Taux journalier {{rate}}",
    vatAndHours: " - TVA {{rate}}% - {{hours}}h/jour",
    editClientTitle: "Modifier {{name}}",
    emptyTitle: "Aucun client pour le moment",
    emptyBody: "Créez votre premier client ci-dessus pour commencer.",
    deleteClientTitle: "Supprimer le client",
    deleteClientBody: "Supprimer « {{name}} » ? Cette action est irréversible.",
    transferHint: "Déplace ce client, ses projets et son temps enregistré vers une organisation que vous possédez.",
    transferTargetOrg: "Organisation cible",
    transferButton: "Transférer",
    transferConfirmTitle: "Transférer le client",
    transferConfirmBody: 'Transférer « {{name}} » vers « {{orgName}} » ? Cette action est irréversible.',
    noOtherOwnedOrgs: "Vous ne possédez aucune autre organisation vers laquelle transférer ce client.",
    invoiceEmails: "Emails de facturation",
    invoiceEmailsHint: "Liste séparée par des virgules ou points-virgules. Utilise l'email du client si vide.",
  },
  projects: {
    title: "Projets",
    createProject: "Créer un projet",
    needClient: "Vous avez besoin d'un client avant de pouvoir créer un projet.",
    dailyRate: "Taux journalier (prioritaire sur celui du client)",
    dailyRateSet: "Taux journalier {{rate}}",
    editProjectTitle: "Modifier {{name}}",
    emptyTitle: "Aucun projet pour le moment",
    emptyBody: "Créez votre premier projet ci-dessus pour commencer.",
    subdivisions: "Subdivisions",
    subdivisionsPlaceholder: "Ajouter une subdivision",
    deleteProjectTitle: "Supprimer le projet",
    deleteProjectBody: "Supprimer « {{name}} » ? Cette action est irréversible.",
    transferHint: "Déplace ce projet vers un autre client au sein de cette organisation.",
    transferTargetClient: "Client cible",
    transferButton: "Transférer",
    transferConfirmBody: "Transférer « {{name}} » vers « {{clientName}} » ? Cette action est irréversible.",
    noOtherClients: "Il n'y a aucun autre client dans cette organisation vers lequel transférer ce projet.",
  },
  admin: {
    usersTitle: "Utilisateurs",
    showFilterUsers: "Afficher les utilisateurs {{filter}}",
    filterAll: "tous",
    deleteUserTitle: "Supprimer l'utilisateur",
    deleteUserBody: "Supprimer « {{email}} » ? Cette action est irréversible.",
    editUserTitle: "Modifier {{email}}",
    pleaseValidUserFields: "Veuillez renseigner un e-mail valide, un prénom et un nom.",
    emailInUse: "Cet e-mail est déjà utilisé.",
    couldNotUpdateUser: "Impossible de mettre à jour cet utilisateur. Veuillez réessayer.",
    globalRole: "Rôle global",
    saveUser: "Enregistrer cet utilisateur",
    organizationsTitle: "Organisations",
    deleteOrgTitle: "Supprimer l'organisation",
    deleteOrgBody: "Supprimer « {{name}} » ? Cette action est irréversible.",
    editOrgTitle: "Modifier {{name}}",
    transferModalTitle: "Transférer la propriété de {{name}}",
    transfer: "Transférer",
    disableMfa: "Désactiver le MFA",
    disableMfaTitle: "Désactiver l'authentification à deux facteurs",
    disableMfaBody: 'Désactiver l\'authentification à deux facteurs pour "{{email}}" ? Cette action est irréversible.',
  },
  apiKeys: {
    title: "Clés API",
    intro: "Créez une clé API pour authentifier des scripts et d'autres outils via l'en-tête X-Api-Key, sans avoir à vous connecter.",
    createKey: "Créer une clé API",
    description: "Description",
    expiresAt: "Date d'expiration (optionnelle)",
    expiresOn: "Expire le {{date}}",
    neverExpires: "N'expire jamais",
    emptyTitle: "Aucune clé API pour le moment",
    emptyBody: "Créez votre première clé API ci-dessus pour commencer.",
    createdTitle: "Clé API créée",
    createdWarning: "Copiez cette clé maintenant - pour votre sécurité, elle ne sera plus jamais affichée.",
    downloadConfig: "Télécharger la configuration CLI",
    showQr: "Afficher le QR code",
    hideQr: "Masquer le QR code",
    deleteKeyTitle: "Révoquer la clé API",
    deleteKeyBody: "Révoquer « {{description}} » ? Tout script qui l'utilise cessera de fonctionner immédiatement.",
    openSwagger: "Documentation de l'API",
  },
  toasts: {
    orgCreated: "Organisation créée.",
    orgUpdated: "Organisation mise à jour.",
    orgDeleted: "Organisation supprimée.",
    memberAdded: "Membre ajouté.",
    dailyRateUpdated: "Taux journalier mis à jour.",
    ownershipTransferred: "Propriété transférée.",
    projectCreated: "Projet créé.",
    clientCreated: "Client créé.",
    projectUpdated: "Projet mis à jour.",
    clientUpdated: "Client mis à jour.",
    clientDeleted: "Client supprimé.",
    clientTransferred: "Client transféré.",
    projectDeleted: "Projet supprimé.",
    userUpdated: "Utilisateur mis à jour.",
    userDeleted: "Utilisateur supprimé.",
    mfaDisabled: "Authentification à deux facteurs désactivée pour cet utilisateur.",
    timeRecordDeleted: "Entrée de temps supprimée.",
    timeRecordUpdated: "Entrée de temps mise à jour.",
    timeRecordCreated: "Entrée de temps créée.",
    apiKeyDeleted: "Clé API révoquée.",
    invoiceGenerated: "Facture générée.",
    invoiceUpdated: "Facture mise à jour.",
    invoiceDeleted: "Facture supprimée.",
    invoiceReuploaded: "Facture rechargée vers les connexions externes.",
    externalConnectionAdded: "Connexion ajoutée.",
    externalConnectionRemoved: "Connexion supprimée.",
    memberRemoved: "Membre supprimé.",
    profilePictureUpdated: "Photo de profil mise à jour.",
    profileUpdated: "Profil mis à jour avec succès.",
    accountCreated: "Compte créé avec succès.",
    loggedIn: "Connexion réussie.",
    passwordResetSent: "Si cette adresse email est enregistrée, un lien de réinitialisation a été envoyé.",
    passwordReset: "Mot de passe mis à jour. Vous pouvez maintenant vous connecter.",
    invoiceSent: "Facture envoyée.",
    contactSent: "Votre message a été envoyé.",
  },
  contact: {
    title: "Nous contacter",
    body: "Une question ou une remarque ? Envoyez-nous un message.",
    subject: "Sujet",
    message: "Message",
    send: "Envoyer le message",
    backToTimeTracking: "Retour au suivi du temps",
  },
  errors: {
    network: "Une erreur est survenue. Veuillez réessayer.",
    internal: "Une erreur est survenue. Veuillez réessayer.",
    notFound: "Ressource introuvable.",
    duplicateEmail: "Cet e-mail est déjà utilisé.",
    userNotFound: "Utilisateur introuvable.",
    invalidCredentials: "Identifiants invalides.",
    nameRequired: "Veuillez renseigner le champ Nom.",
    countryRequired: "Veuillez sélectionner un pays.",
    allFieldsRequired: "Veuillez renseigner tous les champs.",
    invalidUserData: "Données utilisateur invalides.",
    invalidRequestBody: "Requête invalide.",
    invalidMemberInvite: "Veuillez renseigner un e-mail valide et un rôle (administrateur, membre ou lecteur).",
    noUserWithEmail: "Aucun utilisateur avec cet e-mail.",
    invalidRole: "Veuillez renseigner un rôle valide (administrateur, membre ou lecteur).",
    invalidDailyRate: "Veuillez renseigner un taux journalier valide.",
    invalidEmail: "Veuillez renseigner un e-mail valide.",
    invalidCurrency: "Veuillez utiliser une devise prise en charge.",
    cantDeleteOwnAccount: "Vous ne pouvez pas supprimer votre propre compte.",
    invalidAdminUserEdit: "Veuillez renseigner un e-mail, un nom, un prénom et un rôle valides.",
    timeEntryFields: "Veuillez renseigner la description, le client, le projet et le jour.",
    timeEntryStartEnd: "Veuillez renseigner une heure de début et de fin, ou cocher toute la journée.",
    timeEntryAllDayHalf: "Veuillez cocher soit toute la journée, soit demi-journée, mais pas les deux.",
    ownTimeEntriesOnly: "Vous ne pouvez gérer que vos propres entrées de temps.",
    reassignForbidden: "Seul un administrateur ou le propriétaire peut réattribuer une entrée de temps à un autre membre.",
    nameAndSurnameRequired: "Veuillez renseigner le prénom et le nom.",
    passwordsMismatch: "Les mots de passe ne correspondent pas.",
    apiKeyDescription: "Veuillez renseigner une description.",
    invalidExpiration: "Veuillez renseigner une date d'expiration valide.",
    imageTooLarge: "Cette image est trop volumineuse.",
    invalidInvoiceStatus: "Veuillez choisir un statut de facture valide.",
    invalidInvoiceRequest: "Veuillez choisir un client et une période.",
    exportLimitExceeded: "Cette période contient trop d'entrées à exporter. Veuillez restreindre vos filtres ou la période.",
    invalidDateRange: "La date de fin doit être postérieure ou égale à la date de début.",
    cantRemoveOwner: "Le propriétaire de l'organisation ne peut pas être retiré.",
    mustOwnTargetOrg: "Vous devez posséder l'organisation cible pour y transférer un client.",
    invalidClientForOrg: "Ce client n'appartient pas à cette organisation.",
    invalidCountry: "Veuillez sélectionner un pays pris en charge.",
    invalidExternalConnection: "Veuillez remplir tous les champs pour ce type de connexion.",
    duplicateExternalConnection: "Cette connexion externe existe déjà.",
    oidcFailed: "La connexion avec ce fournisseur a échoué. Veuillez réessayer.",
    accountDisabledAdmin: "Votre compte est désactivé. Veuillez contacter un administrateur pour obtenir l'accès.",
    accountDisabledEmail: "Veuillez consulter votre email et cliquer sur le lien de confirmation pour activer votre compte.",
    accountBanned: "Votre compte a été banni par un administrateur.",
    invoiceNumberExists: "Une facture avec ce numéro existe déjà.",
    invalidToken: "Ce lien est invalide ou a expiré.",
    noInvoiceRecipient: "Ce client n'a pas d'adresse email pour l'envoi de la facture.",
    mailLimitExceeded: "Cette organisation a atteint sa limite mensuelle d'emails. Veuillez réessayer après sa réinitialisation.",
    passwordTooShort: "Le mot de passe doit contenir au moins 8 caractères.",
    passwordNoUpper: "Le mot de passe doit contenir une majuscule.",
    passwordNoLower: "Le mot de passe doit contenir une minuscule.",
    passwordNoSymbol: "Le mot de passe doit contenir un caractère spécial.",
    contactFormNotConfigured: "Le formulaire de contact n'est pas disponible pour le moment.",
    contactFormFailed: "Échec de l'envoi de votre message, veuillez réessayer plus tard.",
    contactRateLimited: "Vous envoyez trop de messages. Veuillez patienter avant de réessayer.",
    contactMessageTooShort: "Votre message est trop court. Merci d'ajouter un peu plus de détails.",
    contactGibberish: "Votre message ressemble à du spam. Merci de le reformuler.",
    configTokenRequired: "Jeton de clé API manquant.",
  },
  reports: {
    summary: "Résumé",
    detailed: "Détaillé",
    export: "Exporter",
    exportCsv: "Exporter en CSV",
    exportPdf: "Exporter en PDF",
    total: "Total",
    billable: "Facturable",
    days: "Jours",
    amount: "Montant",
    duration: "Durée",
    time: "Heure",
    noEntries: "Aucune entrée de temps pour cette période.",
    noAccess: "Vous n'avez pas accès aux rapports de cette organisation.",
    chartHint: "Heures suivies par jour pour la période sélectionnée.",
    donutHint: "Heures suivies par projet pour la période sélectionnée.",
    dateRangeShortcuts: "Raccourcis de période",
    shortcuts: "Raccourcis",
    startDate: "Date de début",
    endDate: "Date de fin",
    shortcutToday: "Aujourd'hui",
    shortcutYesterday: "Hier",
    shortcutThisWeek: "Cette semaine",
    shortcutLastWeek: "La semaine dernière",
    shortcutPastTwoWeeks: "Les deux dernières semaines",
    shortcutThisMonth: "Ce mois-ci",
    shortcutLastMonth: "Le mois dernier",
    shortcutPastTwoMonths: "Les deux derniers mois",
    shortcutThisYear: "Cette année",
    shortcutLastYear: "L'année dernière",
  },
  invoices: {
    title: "Factures",
    selectAClient: "Sélectionner un client",
    clientRequired: "Veuillez choisir un client et une période.",
    preview: "Aperçu",
    generate: "Générer",
    previewHint: "L'aperçu se contente de générer le PDF - rien n'est enregistré.",
    generateHint: "Générer enregistre la facture et télécharge son PDF.",
    listTitle: "Factures pour cette période",
    emptyTitle: "Aucune facture pour le moment",
    emptyBody: "Faites un aperçu ou générez-en une ci-dessus pour commencer.",
    number: "Numéro",
    period: "Période",
    status: "Statut",
    total: "Total TTC",
    download: "Télécharger le PDF",
    reupload: "Recharger vers les connexions externes",
    editStatus: "Modifier le statut",
    saveStatus: "Enregistrer le statut",
    statusUnpaid: "Non payée",
    statusPaid: "Payée",
    statusCanceled: "Annulée",
    statusRefunded: "Remboursée",
    noAccess: "Vous n'avez pas accès aux factures de cette organisation.",
    deleteInvoiceTitle: "Supprimer la facture",
    deleteInvoiceBody: "Supprimer la facture « {{number}} » ? Cette action est irréversible.",
    generateWithId: "Générer avec un id",
    generateWithIdHint: "Générer une facture avec un id spécifique plutôt que celui calculé habituellement.",
    generateWithIdTitle: "Générer une facture avec un id",
    invoiceIdLabel: "Id de la facture",
    invoiceIdPlaceholder: "ex. CLIENT202601011",
    invoiceIdRequired: "Veuillez saisir un id de facture.",
    sendInvoice: "Envoyer la facture par email",
  },
  exportJobs: {
    title: "Tâches d'export",
    create: "Créer une tâche d'export",
    newJob: "Nouvelle tâche d'export",
    editJob: "Modifier la tâche d'export",
    emptyTitle: "Aucune tâche d'export pour le moment",
    emptyBody: "Créez-en une ci-dessus pour planifier des exports de rapports automatisés.",
    enabled: "Activé",
    disabled: "Désactivé",
    enable: "Activer cette tâche",
    disable: "Désactiver cette tâche",
    runNow: "Exécuter maintenant",
    runNowSuccess: "Tâche d'export démarrée",
    nextRunTooltip: "Heure de la prochaine exécution",
    nextRunNow: "maintenant",
    needOrganization: "Veuillez sélectionner une organisation pour gérer les tâches d'export.",
    needAdminAccess: "Seuls les administrateurs peuvent gérer les tâches d'export.",
    cronExpression: "Expression Cron",
    cronExpressionRequired: "Veuillez saisir une expression cron.",
    timePeriod: "Période de temps",
    timePeriodRequired: "Veuillez sélectionner une période de temps.",
    reportTypes: "Types de rapports",
    selectReportTypes: "Sélectionnez les types de rapports à exporter",
    clients: "Clients",
    allClientsSelected: "Tous les clients seront inclus",
    projects: "Projets",
    allProjectsSelected: "Tous les projets seront inclus",
    includeFinancialData: "Inclure les données financières dans les rapports",
    targetsLabel: "Cibles",
    selectTargets: "Veuillez ajouter au moins une cible.",
    toEmails: "À (séparés par des virgules ou points-virgules)",
    ccEmails: "CC (séparés par des virgules ou points-virgules)",
    targetTypeEmail: "Email",
    targetType: "Type de cible",
    addTarget: "Ajouter une cible",
    removeTarget: "Supprimer la cible",
    jobNamePlaceholder: "ex. Rapport résumé quotidien",
    createdSuccessfully: "Tâche d'export créée avec succès",
    updatedSuccessfully: "Tâche d'export modifiée avec succès",
    deletedSuccessfully: "Tâche d'export supprimée avec succès",
    deleteConfirmTitle: "Supprimer la tâche d'export",
    deleteConfirmMessage: "Supprimer la tâche d'export « {{name}} » ? Cette action est irréversible.",
  },
};

export default fr;
